<template lang="pug">
  app-modal(
    :titulo="titulo",
    :width="width"
    @closeModal="$emit('closeModal')"
  )

    template(slot="body")
      div
        app-pdf-slider(
          v-if="arrayBuffer && isMultiple && !isImagem"
          :documentosBytes="arrayBuffer"
          @changePdfDownload="changePdfDownload"
        )
        app-pdf-viewer(
          v-else-if="!isImagem"
          :bytes="arrayBuffer"
        )
      app-image-viewer(
        :bytes="bytes"
        :base64="base64"
        v-if="(bytes || base64) && (!arrayBytes || !arrayBytes.length) && isImagem && visualizarDocumentosPDF "
      )

    template(slot="footer", v-if="!imprimir && showFooter")
      div.flex
        el-button(@click="downloadPdf", v-if="!isImagem")
          i.fal.fa-file-pdf
          span &nbsp Exportar PDF
        el-button(@click="downloadPdf" v-if="isImagem")
          i.fal.fa-file-pdf
          span &nbsp Exportar Imagem
    template(slot="footer", v-if="imprimir")
      div.flex
        el-button(@click="imprimirPDF")
          i.fal.fa-print
          span &nbsp Imprimir

</template>

<script>
import AppModal from '@/components/AppModal'
import AppPdfViewer from '@/components/AppPDFViewer'
import AppPdfViewerOld from '@/components/AppPDFViewerOld'
import AppPdfSlider from '@/components/AppPDFSlider'
import FileHelper from '@/utils/fileHelper'
import AppImageViewer from '@/components/AppImageViewer'
import { mapActions } from 'vuex'
const regrasAnalise = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {
  components: {
    AppModal,
    AppPdfViewer,
    AppPdfViewerOld,
    FileHelper,
    AppPdfSlider,
    AppImageViewer
  },

  data () {
    return {
      bytes: null,
      arrayBytes: [],
      despachos: [],
      despachoAtual: null,
      visualizarDocumentosPDF: false
    }
  },

  props: {
    width: {
      type: Number,
      default: window.innerWidth * 0.85
    },
    tipo: {
      type: String,
      default: null
    },
    titulo: {
      type: String,
      required: true
    },
    isProcesso: {
      type: Boolean,
      default: false
    },
    isMultiple: {
      type: Boolean,
      default: false
    },
    isImagem: {
      type: Boolean,
      default: false
    },
    tituloDocumento: {
      type: String,
      required: false
    },
    isNotId: {
      type: Boolean,
      default: false,
      required: false
    },
    imprimir: {
      type: Boolean,
      default: false
    },
    tipoProcesso: {
      type: String
    },
    isVisualisaProcessoDespacho: {
      type: Boolean
    },
    arrayBuffer: {
      required: false
    },
    base64: {
      type: String
    },
    showFooter: {
      type: Boolean,
      default: true
    }
  },

  async mounted () {
    if (this.arrayBuffer) {
      this.bytes = this.arrayBuffer
    }
    this.visualizarDocumentosPDF = regrasAnalise.visualizarDocumentosPDF.active
  },

  methods: {
    ...mapActions({
      getDespachosByProcessoETipo: 'despacho/findByFilter',
      getArrayTituloByDespachoId: 'despacho/getArrayTituloByDespachoId',
      getArrayTituloByProcessoId: 'despacho/getArrayTituloByProcessoId',
      getArrayRetificacaoTituloByDespachoId: 'despacho/getArrayRetificacaoTituloByDespachoId'
    }),
    async downloadPdf () {
      if (this.tituloDocumento != null) {
        FileHelper.saveFile(this.bytes, this.tituloDocumento)
      } else {
        FileHelper.saveFile(this.bytes, this.titulo)
      }
    },
    imprimirPDF () {
      //! TODO funcao feita para imprimir o pdf
      const blob = new Blob([this.bytes], { type: 'application/pdf' })
      const blobURL = URL.createObjectURL(blob)
      const printWindow = window.open(blobURL)
      printWindow.onload = () => {
        printWindow.print()
      }
    },
    changePdfDownload (documento) {
      this.bytes = documento.bytes
      this.despachoAtual = this.despachos.find(
        despacho => despacho.id === documento.id
      )
    }
  }
}
</script>

<style scoped lang="scss">
p.message {
  width: 80%;
  margin: 0 auto;
}

.flex {
  display: flex;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/AppModalVisualizaPdf.vue